import { ColumnConfig } from './Field';
import { SectionData } from './Section';

export function areSectionsSavable(
  sections: SectionData[],
  columnConfigs?: ColumnConfig[],
): boolean {
  const textConfig = columnConfigs?.find((c) => c.fieldName === 'text');

  for (const section of sections) {
    if (!section.name.trim()) return false;

    for (const field of section.fields) {
      if (!field.fieldType) return false;
      if (!field.title.trim()) return false;

      if (textConfig?.maxLength && field.title.length > textConfig.maxLength) {
        return false;
      }

      if (field.fieldType === 'multi_options' && !field.skipOptionDefinition) {
        for (const option of field.options) {
          if (!option.name.trim()) return false;
        }
      }
    }
  }

  return true;
}

export function getFieldError(
  sections: SectionData[],
  sectionId: number,
  fieldId: number,
  columnConfigs?: ColumnConfig[],
): string | null {
  const section = sections.find((s) => s.cId === sectionId);
  if (!section) return null;

  const field = section.fields.find((f) => f.clientId === fieldId);
  if (!field) return null;

  const textConfig = columnConfigs?.find((c) => c.fieldName === 'text');
  if (textConfig?.maxLength && field.title.length > textConfig.maxLength) {
    return `Maximum ${textConfig.maxLength} characters allowed. Currently ${field.title.length}.`;
  }

  return null;
}
